// Central content + config. Swap media/text here without touching components.

export const CONFIG = {
  whatsapp: "917850911096",
  whatsappMsg: "Hi Sanvalio, I'd like to discuss a project.",
  email: "support@sanvalio.com",
  calendlyUrl: "https://calendly.com/sanvalio51/30min", // paste Calendly link here later to enable native embed
  // Drop your Sora/Veo showreel .mp4 URL here — hero swaps to video automatically.
  showreelVideo: "/showreel.mp4",
  showreelWebm: "/showreel.webm",
  heroPoster: "https://static.prod-images.emergentagent.com/jobs/85dace83-1a90-4dc9-a55c-4054e35f40bf/images/41aee6e3a43224adb7f571eb908bb5b97c98d209a822ff26741f6cd106b1b60d.jpeg",
};

export const STATS = [
  { value: "120+", label: "Brands Served" },
  { value: "250+", label: "Projects Delivered" },
  { value: "12+", label: "Years of Experience" },
  { value: "100%", label: "Result Driven" },
];

export const SPECIALTIES = [
  { icon: "TrendingUp", label: "Performance Marketing" },
  { icon: "Gem", label: "Branding & Identity" },
  { icon: "Box", label: "CGI Ads & Animation" },
  { icon: "MonitorSmartphone", label: "Websites & UI/UX" },
  { icon: "Camera", label: "Product Photography" },
  { icon: "Plane", label: "Drone Shoots" },
  { icon: "Clapperboard", label: "Video & Motion Graphics" },
];

export const SERVICES_V2 = [
  { icon: "Globe", t: "Website Design", d: "Cinematic, high-converting sites engineered in React with buttery WebGL motion." },
  { icon: "Clapperboard", t: "Cinematic Ads", d: "Scroll-stopping brand films shot and graded with a director's eye." },
  { icon: "Boxes", t: "CGI Ads", d: "Photoreal computer-generated ads that break the laws of physics." },
  { icon: "Orbit", t: "3D Walkthrough", d: "Immersive architectural & product walkthroughs that sell before it's built." },
  { icon: "Gem", t: "Branding", d: "Identity systems that make premium brands impossible to forget." },
  { icon: "TrendingUp", t: "Performance Marketing", d: "High-ROI funnels & paid campaigns tuned for high-ticket conversions." },
  { icon: "Workflow", t: "Automation", d: "Custom workflows that run your growth engine while you sleep." },
  { icon: "Bot", t: "AI Agents", d: "Bespoke AI agents that qualify leads, support customers and scale ops." },
];

export const SERVICES = [
  {
    id: "branding",
    no: "01",
    title: "Branding & Strategy",
    desc: "Identity systems, positioning and guidelines that make premium brands unforgettable.",
    tags: ["Identity", "Positioning", "Guidelines"],
    image: "https://images.pexels.com/photos/9550788/pexels-photo-9550788.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    span: "lg:col-span-3 lg:row-span-2",
  },
  {
    id: "performance",
    no: "02",
    title: "Performance Marketing",
    desc: "High-ROI paid social, funnels and campaigns engineered for high-ticket conversions.",
    tags: ["Paid Social", "Funnels", "CRO"],
    image: "https://images.unsplash.com/photo-1622737133809-d95047b9e673?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    span: "lg:col-span-3",
  },
  {
    id: "software",
    no: "03",
    title: "Web / App / Software",
    desc: "High-performance React & custom software with cinematic WebGL experiences.",
    tags: ["React", "WebGL", "Product"],
    image: "https://images.unsplash.com/photo-1517241034903-9a4c3ab12f00?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    span: "lg:col-span-3",
  },
  {
    id: "cgi",
    no: "04",
    title: "3D & CGI Motion",
    desc: "Photorealistic renders and architectural visualisation that sell before it's built.",
    tags: ["3D", "Render", "ArchViz"],
    image: "https://images.unsplash.com/photo-1697899001862-59699946ea29?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    span: "lg:col-span-2",
  },
  {
    id: "film",
    no: "05",
    title: "Film & Photography",
    desc: "Commercial production, brand films and studio shoots with a director's eye.",
    tags: ["Film", "Photo", "Studio"],
    image: "https://images.unsplash.com/photo-1681137063068-081072cf04b4?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    span: "lg:col-span-4",
  },
];

export const FILTERS = ["All", "Branding", "Web & App", "3D / CGI", "Film"];

export const PROJECTS = [
  {
    id: "p1", title: "Aurelia Residences", client: "Luxury Real Estate", category: "3D / CGI",
    image: "https://images.unsplash.com/photo-1611048267451-e6ed903d4a38?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    tags: ["ArchViz", "Film", "Web"],
    challenge: "Pre-sell a ₹400Cr residential tower before a single floor was built.",
    solution: "Photoreal CGI walkthroughs, a cinematic launch film and an immersive booking microsite.",
    metrics: [["68%", "units pre-sold"], ["3.2x", "avg. enquiry value"], ["11", "cities reached"]],
  },
  {
    id: "p2", title: "Noir & Bloom", client: "D2C Spirits", category: "Branding",
    image: "https://images.pexels.com/photos/35667420/pexels-photo-35667420.png?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    tags: ["Identity", "Packaging", "Photo"],
    challenge: "Launch a premium craft-spirit brand into a crowded shelf.",
    solution: "A bold obsidian identity, sculptural packaging and splash-lit product photography.",
    metrics: [["4.6%", "conversion rate"], ["₹9Cr", "first-year GMV"], ["2M+", "organic reach"]],
  },
  {
    id: "p3", title: "Meridian Health", client: "Hospital Group", category: "Web & App",
    image: "https://images.unsplash.com/photo-1704040686413-2c607dbd2f06?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    tags: ["Product", "React", "Design System"],
    challenge: "Modernise patient booking across 14 hospitals with one platform.",
    solution: "A calm, accessible design system and a fast appointment app with real-time slots.",
    metrics: [["41%", "more bookings"], ["-55%", "call-centre load"], ["4.8★", "app rating"]],
  },
  {
    id: "p4", title: "Solene Interiors", client: "Interior Design Studio", category: "Film",
    image: "https://images.unsplash.com/photo-1598928387577-d49b6d399110?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    tags: ["Brand Film", "Photo", "Social"],
    challenge: "Position a boutique studio for ultra-high-net-worth clientele.",
    solution: "A slow, tactile brand film and editorial photography suite for launch.",
    metrics: [["7", "premium leads/mo"], ["3.9x", "watch-through"], ["1.4M", "views"]],
  },
  {
    id: "p5", title: "Kairos Coaching", client: "Elite Coach", category: "Web & App",
    image: "https://images.unsplash.com/photo-1622737133809-d95047b9e673?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    tags: ["Funnel", "Web", "Ads"],
    challenge: "Scale a personal-brand coaching business past a plateau.",
    solution: "A high-converting funnel, paid-social engine and a magnetic personal-brand site.",
    metrics: [["6.1x", "ROAS"], ["₹2.3Cr", "launch revenue"], ["38%", "opt-in rate"]],
  },
  {
    id: "p6", title: "Verve Carpets", client: "Manufacturer", category: "3D / CGI",
    image: "https://images.unsplash.com/photo-1697899001862-59699946ea29?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    tags: ["3D", "Catalogue", "Render"],
    challenge: "Show 200+ SKUs in room settings without endless photoshoots.",
    solution: "A CGI pipeline rendering every design in curated interior scenes on demand.",
    metrics: [["-72%", "shoot cost"], ["200+", "SKUs rendered"], ["2.4x", "catalogue engagement"]],
  },
  {
    id: "p7", title: "Celeste Hotels", client: "Luxury Resort", category: "Branding",
    image: "https://images.unsplash.com/photo-1598928506311-c55ded91a20c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    tags: ["Identity", "Web", "Film"],
    challenge: "Rebrand a resort group for the global luxury traveller.",
    solution: "A champagne-gold identity, cinematic property films and a direct-booking site.",
    metrics: [["29%", "direct bookings"], ["₹18Cr", "revenue lift"], ["4.9★", "guest score"]],
  },
  {
    id: "p8", title: "Atlas Studio Reel", client: "Commercial Production", category: "Film",
    image: "https://images.pexels.com/photos/8089650/pexels-photo-8089650.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    tags: ["Showreel", "Grade", "Direction"],
    challenge: "Craft a flagship showreel to win enterprise film contracts.",
    solution: "Directed, shot and colour-graded a 90-second cinematic brand reel.",
    metrics: [["5", "enterprise wins"], ["₹6Cr", "pipeline"], ["82%", "reply rate"]],
  },
];

export const INDUSTRIES = [
  "Real Estate", "Luxury Hotels & Resorts", "Hospitals & Doctors", "Elite Coaches",
  "Astrologers", "Interior Designers", "Carpet & Furniture", "Home Furnishing",
  "Clothing & Apparel", "D2C / B2C / B2B Brands",
];

export const MANIFESTO = [
  { no: "01", title: "Emotion over algorithms", body: "Metrics matter, but people buy feeling first. We design the emotional arc before the funnel." },
  { no: "02", title: "Craftsmanship without compromise", body: "Every frame, pixel and word is treated like it's going on a billboard. Because often, it is." },
  { no: "03", title: "Precision engineering meets cinema", body: "We blend film-grade art direction with performance-obsessed engineering. Beautiful that also converts." },
];

export const TESTIMONIALS = [
  { quote: "Sanvalio didn't just rebrand us — they repositioned us into a category of one. Bookings followed instantly.", name: "Aarav Mehta", role: "MD, Celeste Hotels" },
  { quote: "The CGI launch let us pre-sell most of the tower before construction. Nothing short of transformative.", name: "Priya Nair", role: "VP Sales, Aurelia" },
  { quote: "Cinematic work with the discipline of a performance agency. Rare combination, real results.", name: "Daniel Ross", role: "Founder, Kairos" },
  { quote: "Our catalogue costs dropped and engagement doubled. The 3D pipeline paid for itself in a quarter.", name: "Rohit Agarwal", role: "Director, Verve" },
];

export const CLIENTS = ["AURELIA", "CELESTE", "MERIDIAN", "SOLENE", "KAIROS", "VERVE", "NOIR&BLOOM", "ATLAS"];

export const NAV = [
  { label: "Services", href: "#services" },
  { label: "Industries", href: "#industries" },
  { label: "Manifesto", href: "#manifesto" },
  { label: "Contact", href: "#contact" },
];
